export class ConsultarEventosConstants {
  public static readonly STORAGE_KEY = "consultar_eventos_filtros";
  public static readonly AGENDA_AMBOS = "ambos";

  public static readonly AGENDA_REGULATORIA_LISTA = [
    { label: "Ambos", value: ConsultarEventosConstants.AGENDA_AMBOS },
    { label: "Sim", value: "S" },
    { label: "Não", value: "N" },
  ];
}
